import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import actions from "../../actions"
import { action } from '../';
import WCAuthorization from '../WCAuthorization';

class SocketProvider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSocketOpen: false,
            socketAction: undefined,
            messageListener: undefined,
            isOnline: true
        }
        window.socket = this.restartSocket;
    }

    static getDerivedStateFromProps(props, state) {
        const { isOnline } = props;
        return { isOnline };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.isOnline !== this.state.isOnline;
    }

    componentDidUpdate() {
        if (this.state.isOnline) this.restartSocket()
    }

    componentWillUnmount() {
        this.removeEventListener();
    }

    restartSocket = (action) => {
        let messageListener = window.socketMessage;
        const { isConnecting } = this.props;
        if (isConnecting === "connecting") {
            let { socketAction } = this.state;
            socketAction = socketAction || [];
            if (action) socketAction.push(action);
            this.setState({ socketAction, messageListener })
            return;
        } else if (isConnecting === "connected") return;
        this.openWSconnection(messageListener)
    }

    _delayAction = () => {
        const { socketAction } = this.state;
        if (!socketAction) return;
        socketAction.map(item => this.props.sendSocketmessage(item))
        this.setState({ socketAction: undefined })
    }


    // send = (data) => {
    //     try {
    //         if (window.wsConnection) {
    //             if (window.wsConnection.readyState === window.wsConnection.OPEN) {
    //                 return window.wsConnection.send(JSON.stringify(data));
    //             }
    //         }
    //         window.socket(this.socketMessageListener)     // open socket connection
    //     } catch (error) {
    //         console.log(error)
    //         setTimeout(() => {
    //             window.socket(this.socketMessageListener)
    //         }, 20000);
    //     }
    // }

    openWSconnection = (messageListener) => {
        const { isOnline, Connecting, Connected, Die } = this.props;
        let { isSocketOpen } = this.state;
        if (!messageListener) messageListener = this.state.messageListener;
        if (isSocketOpen || !isOnline) {
            clearInterval(this.socketInterval)
            return false;
        }
        Connecting();
        window.wsConnection = new WebSocket(window.socketURL);
        window.wsConnection.addEventListener("open", () => {
            console.log("Connection open.")
            Connected()
            isSocketOpen = window.wsConnection.readyState === window.wsConnection.OPEN;
            this.setState({ isSocketOpen });
            this.socketInterval = setInterval(() => {
                if (window.wsConnection.readyState === window.wsConnection.OPEN)
                    return window.wsConnection.send(1);
                return clearInterval(this.socketInterval)
            }, 50000);
        });

        if (messageListener) window.wsConnection.addEventListener("message", messageListener);
        window.wsConnection.addEventListener("message", this.socketMessageListener);
        window.wsConnection.addEventListener("close", (e) => {
            Die();
            isSocketOpen = window.wsConnection.readyState === window.wsConnection.OPEN;
            this.setState({ isSocketOpen });

            if (e.code === 3000) return console.log("Connection Die!");
            console.log("Connection closed!", e)
            if (e.code === 1006) return this.openWSconnection()
            setTimeout(() => {
                this.openWSconnection()
                return;
            }, 3000);
        });

        // if (window.closedListener) window.wsConnection.addEventListener("close", window.closedListener);

        window.wsConnection.addEventListener("error", (e) => {
            Die();
            this.setState({ isSocketOpen: false });
            console.log("Socket connection Error :-", e);
        });
        return true;
    }

    socketMessageListener = (event) => {
        const { setSocketLoginState, setSocketLogoutState, socketLogin } = this.props;
        let data = JSON.parse(event.data);
        // console.log(data)
        switch (data.cmd) {
            case "User.connect": return socketLogin();
            case "User.login":
                this._delayAction()
                return setSocketLoginState();

            case "GroupMessage.send.ACK": return this._promptGropMessages(data)

            case "GroupMessage.receive":
                this._promptGropMessages(data)
                this.props.notification(data);
                return;

            case "GroupEvent.receive":
                return this.props.notification(data);

            case "User.error":
                setSocketLogoutState();
                return socketLogin();

            default:
                return;
        }
    }

    _promptGropMessages = (message) => {
        let { userInfo, groupConversation, updateConversations } = this.props;
        let messageUser = {
            sender: userInfo.id,
            sender_nickname: userInfo.nickname,
            sender_avatar: userInfo.avatar,
        }
        if (message.cmd === "GroupMessage.receive")
            messageUser = {
                sender: message.sender,
                sender_nickname: message.sender_name,
                sender_avatar: message.sender_avatar,
            }
        let index = groupConversation.findIndex(item => item.target === message.target);
        let unread_amount = 0;
        if (groupConversation) {
            if (groupConversation[index])
                unread_amount = groupConversation[index].unread_amount + 1;
        }
        else unread_amount = 1;
        groupConversation[index] = {
            ...groupConversation[index],
            unread_amount,
            type: message.type,
            message: message.message,
            client_id: message.client_id,
            time: message.time,
            ...messageUser
        }
        groupConversation = groupConversation.sort((a, b) => parseFloat(b.time) - parseFloat(a.time));
        updateConversations(groupConversation);
    }

    render() {
        return <React.Fragment>
            <WCAuthorization openSocket={() => this.openWSconnection()}>
                {this.props.children}
            </WCAuthorization>
        </React.Fragment>
    }

    removeEventListener = () => {
        clearInterval(this.socketInterval);
        if (window.wsConnection) {
            window.wsConnection.removeEventListener('open', () => window.wsConnection = undefined);
            window.wsConnection.removeEventListener('close', () => window.wsConnection = undefined);
            window.wsConnection.removeEventListener('error', () => window.wsConnection = undefined);
        }
    }
}

function mapStateToProps({ setting, auth, chat }) {
    return {
        isOnline: setting.isOnline,
        isConnecting: chat.isConnecting,
        groupConversation: chat.groupConversation,
        userInfo: auth.userInfo,
        isLogin: auth.isLogin
    }
}

const mapDispatch = (dispatch) => {
    return {
        notification: request => dispatch(actions.notifyBrowser(request)),
        socketLogin: () => dispatch(actions.socketLogin()),
        getHistory: (data) => dispatch(actions.getHistory(data)),
        sendSocketmessage: (data) => dispatch(actions.sendSocketmessage(data)),

        setSocketLoginState: () => dispatch({ type: action.IS_SOCKET_LOGIN }),
        setSocketLogoutState: () => dispatch({ type: action.IS_SOCKET_LOGOUT }),

        Connecting: () => dispatch({ type: action.IS_SOCKET_CONNECTING }),
        Connected: () => dispatch({ type: action.IS_SOCKET_CONNECTED }),
        Die: () => dispatch({ type: action.IS_SOCKET_DIE }),
        updateConversations: (groups) => dispatch({ type: action.CONVERSATION_LIST, groups }),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatch)(SocketProvider));
